/** Source IDs offered by the existing individual access-policy administration UI. */
export const SOURCE_RESOURCE_IDS = [
  'salesforce', 'line', 'fieldy', 'slack', 'gmail', 'kintone', 'chatwork',
  'notion', 'plaud', 'omi', 'google', 'zoom_phone', 'zoom_meeting', 'file',
] as const
